module.exports = __webpack_public_path__ + "static/media/Arrow_up_solid.ddca84d4.svg";